<template>
  <div class="filtering-facets" :class="{ sticky: showSticky }">
    <div ref="el" class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9 large-10">
        <FilteringFacetsList />
        <FilteringFacetsSelectedFacets />
      </div>

      <div class="cell small-3 medium-3 large-2 hide-for-small-only">
        <FilteringFacetsSortByCriteria />
      </div>
    </div>

    <FilteringFacetsSortAndFilter />
  </div>
</template>

<script setup>
import { useResizeObserver } from '@vueuse/core';

/** scroll sticky* */
const onlyMobile = true;
const scrollDir = 'up'; // up for show on scroll up, down for show on scroll down
const { showSticky } = useScrollSticky(onlyMobile, scrollDir);
/** scroll sticky ends * */

const filteringFacetsStore = useFilteringFacetsStore();
const props = defineProps({
  facets: {
    type: Array,
    required: true,
  },
  sortBy: {
    type: Array,
    required: true,
  },
});
const allSelectedCriteria = computed(() => filteringFacetsStore.allSelectedCriteria);

const el = ref(null);
const emit = defineEmits(['selectedCriteria']);

const { updateFacetsFilter } = useFacetOptions();

watch(
  () => props.facets,
  (newFacets) => {
    filteringFacetsStore.addFacetOptions({
      facets: newFacets,
    });
  },
  { immediate: true },
);

// Pinia: listen for the action using $onAction
const unsubscribe = filteringFacetsStore.$onAction(({ name, after }) => {
  after(() => {
    // adjust the action name to match your Pinia action name
    if (name === 'getAllSelectedCriteria') {
      emit('selectedCriteria', {
        allSelected: allSelectedCriteria.value,
      });
    }
  });
});
filteringFacetsStore.addSortByOptions({
  sortBy: props.sortBy,
});
// Setup resize observer with proper cleanup
const { stop: stopResizeObserver } = useResizeObserver(
  el,
  () => {
    updateFacetsFilter(filteringFacetsStore);
  },
  { box: 'border-box' },
);

// Cleanup on component unmount
onUnmounted(() => {
  stopResizeObserver();
  unsubscribe();
});
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  z-index: 20;
  background: $white;
  top: 0;
}
</style>
